module.exports = __webpack_public_path__ + "static/media/video_thumb5.ad2acf71.png";